export const TOGGLE_APP_DRAWER_MUTATION = 'TOGGLE_APP_DRAWER_MUTATION'
export const SET_DRAWER_STATE_MUTATION = 'SET_DRAWER_STATE_MUTATION'
export const SET_ERROR_RESPONSE_DIALOG_DATA = 'SET_ERROR_RESPONSE_DIALOG_DATA'
export const SHOW_PROFILE_DIALOG_MUTATION = 'SHOW_PROFILE_DIALOG_MUTATION'

//<editor-fold desc="Auth Module Mutations">
export const AUTH_SET_CURRENT_USER_MUTATION = 'AUTH_SET_CURRENT_USER_MUTATION'
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN'
export const SET_INVALID_TOKEN_MUTATION = 'SET_INVALID_TOKEN_MUTATION'
export const SET_IS_ORDER_CONFIRMATION_MUTATION = 'SET_IS_ORDER_CONFIRMATION_MUTATION'
export const SET_IS_DELETE_CONFIRMATION_MUTATION = 'SET_IS_DELETE_CONFIRMATION_MUTATION'
//</editor-fold>

//<editor-fold desc="Auth Module Mutations">
export const SETTINGS_REPLACE = 'SETTINGS_REPLACE'
//</editor-fold>

export const SET_CURRENT_USER_DAILYMENU = 'SET_CURRENT_USER_DAILYMENU'
export const SET_CURRENT_DAILYMENU_OFFER = 'SET_CURRENT_DAILYMENU_OFFER'
export const SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER = 'SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER'
export const SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET = 'SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET'
export const SET_DATA_CHANGED = 'SET_DATA_CHANGED'
export const SET_DAILYMENU_OFFER_CHANGE_SET = 'SET_DAILYMENU_OFFER_CHANGE_SET'
export const SET_SELECTED_VIEW = 'SET_SELECTED_VIEW'
export const SET_LOADING_DAILYMENU = 'SET_LOADING_DAILYMENU'
export const SET_CURRENT_USER_RESERVATION_RANGE_DATA = 'SET_CURRENT_USER_RESERVATION_RANGE_DATA'
export const SET_DAILY_MENU_TOP_GROUP_SAVED = 'SET_DAILY_MENU_TOP_GROUP_SAVED'
export const SET_USER_SETTINGS_4_ORDERING = 'SET_USER_SETTINGS_4_ORDERING'

export const SET_CALENDAR_EVENTS = 'SET_CALENDAR_EVENTS'

export const SET_SELECTED_MENU_ITEM_MUTATION = 'SET_SELECTED_MENU_ITEM_MUTATION'

export const SET_MODE_MUTATION = 'SET_MODE_MUTATION'
export const SET_CONTROL_BUTTONS_MODE_MUTATION = 'SET_CONTROL_BUTTONS_MODE_MUTATION'

export const SET_CID_MODE_MUTATION = 'SET_CID_MODE_MUTATION'
export const SET_TT_MODE_MUTATION = 'SET_TT_MODE_MUTATION'
export const SET_SHOW_LOGOUT_BUTTON_MODE_MUTATION = 'SET_SHOW_LOGOUT_BUTTON_MODE_MUTATION'
export const SET_SHOW_LOGOUT_TIMER_MODE_MUTATION = 'SET_SHOW_LOGOUT_TIMER_MODE_MUTATION'
export const SET_CURRENT_UI_LANGUAGE = 'SET_CURRENT_UI_LANGUAGE'



